import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useCurrentCalculation } from '@/composables/useCurrentCalculation';
import { useCurrentEstimatedSegments } from '@/composables/useCurrentEstimatedSegments';
import { useCalculatorSummaryEstimated } from '@/composables/useCalculatorSummaryEstimated';
import { useCalculatorEstimated } from '@/composables/useCalculatorEstimated';
import { useClientsStore } from '@/store/clients';
import { buildCalculationFileName } from '@/utils/calculationFileName';
import { buildCalculationSummaryCsvRows } from '@/utils/calculationSummaryCsv';
import { downloadCsv } from '@/utils/downloadCsv';

export function useDownloadCalculationSummaryCsv() {
  const route = useRoute();
  const { currentCalculation } = useCurrentCalculation();
  const { regularSegments, financingSegments } = useCurrentEstimatedSegments();
  const { calculationRules } = useCalculatorEstimated();
  const { rules } = useCalculatorSummaryEstimated(Number(route.params.calculatorId));
  const clientsStore = useClientsStore();

  const currentClient = computed(() => {
    const clientUuid = currentCalculation.value?.client_uuid;

    if (!clientUuid) {
      return null;
    }

    return clientsStore.getClientByUuid(clientUuid) ?? null;
  });

  const rows = computed(() =>
    buildCalculationSummaryCsvRows({
      client: currentClient.value,
      sidebarRules: calculationRules.value,
      widgetRules: rules.value,
      regularSegments: regularSegments.value,
      financingSegments: financingSegments.value,
    })
  );

  const hasRows = computed(() => rows.value.length > 0);

  function downloadCalculationSummaryCsv() {
    if (!hasRows.value) {
      return;
    }

    const fileName = buildCalculationFileName({
      prefix: 'podsumowanie_kalkulacji',
      calculation: currentCalculation.value,
      client: currentClient.value,
      includeCopyMarker: true,
    });

    downloadCsv(
      ['Nazwa', 'Wartość', 'Jednostka', 'Sekcja'],
      rows.value.map((row) => [row.name, row.value, row.unit, row.section]),
      fileName
    );
  }

  return {
    downloadCalculationSummaryCsv,
    hasRows,
  };
}
